import React from 'react';
import { connect } from 'react-redux';
import StatisticsByDayMetrics from './StatisticsByDayMetrics.js';
import actions from './StatisticsByDayMetrics.actions';
import {
    mainSelector,
    getMetrics
} from './StatisticsByDayMetrics.selectors';
import ReportByDayComponent from '../../../../utils/ReportByDayComponent/ReportByDayComponent';

const reportUtils = ReportByDayComponent.utils;

const StatisticsByDayMetricsComponent = connect(
    function mapStateToProps(state, ownProps) {
        const data = mainSelector(state);
        const fallbackMetrics = getMetrics(state);
        const metrics = typeof ownProps.metrics === 'string' && ownProps.metrics.length
            ? ownProps.metrics
            : fallbackMetrics;
        const checkedKeys = reportUtils.getKeysMetric(metrics || reportUtils.getDefStrMetric());

        return {
            data,
            metrics,
            checkedKeys,
            location: state.routing.locationBeforeTransitions
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
            saveServerStorage: actions.saveServerStorage
        };
    }
)(StatisticsByDayMetrics);

export default StatisticsByDayMetricsComponent;
